import React from 'react';

const CoronaDataContext = React.createContext(null);

export default CoronaDataContext;
